import React from "react";
import Box from "@mui/material/Box";

function Pre({ load }) {
  return (
    <Box
      id={load ? "preloader" : "preloader-none"}
      role="status"
      aria-live="polite"
      aria-label="Loading portfolio"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 999999,
        backgroundColor: "#0a0a0f",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: load ? 1 : 0,
        pointerEvents: load ? "auto" : "none",
        transition: "opacity 0.5s ease",
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          width: 60,
          height: 60,
          borderRadius: "50%",
          border: "3px solid rgba(0, 127, 255, 0.1)",
          borderTopColor: "#007FFF",
          animation: "spin 1s linear infinite",
          "@keyframes spin": {
            to: {
              transform: "rotate(360deg)",
            },
          },
        }}
      />
      <Box
        component="span"
        sx={{
          border: 0,
          clip: "rect(0 0 0 0)",
          height: 1,
          margin: -1,
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: 1,
        }}
      >
        Loading portfolio
      </Box>
    </Box>
  );
}

export default Pre;
